import React from 'react';
import { Card, CardBody, Label } from 'reactstrap';
import ParcelField from '../shared/ParcelField';
import ParcelIncotermTable from './ParcelIncotermTable';
import { mapHpsParcelIncotermRows } from './utils';

const HpsParcelNonLpg = ({
  parcels = [],
  quantityUnitLabel = 'MB',
  usesDyedUndyed = true,
  alphaColumnLabel = 'Alpha',
}) =>
  parcels.map((parcel, index) => (
    <Card key={parcel.id || index} className='border shadow-sm mb-3'>
      <CardBody>
        <ParcelField parcel={parcel} />

        <div className='mt-3'>
          <Label className='fw-semibold small text-dark mb-2'>Incoterm</Label>
          <ParcelIncotermTable
            rows={mapHpsParcelIncotermRows(parcel)}
            quantityUnitLabel={quantityUnitLabel}
            usesDyedUndyed={usesDyedUndyed}
            alphaColumnLabel={alphaColumnLabel}
          />
        </div>
      </CardBody>
    </Card>
  ));

export default HpsParcelNonLpg;
